/* Swell bundle subscription tier reconciliation.
 * Scope: tagged full-size bundle bars on the approved four-month plan only.
 * This does not change existing subscription contracts or product-page offers.
 */
(()=>{
 'use strict';
 if(window.SWELL_UNIFORM_PRICING_ENABLED)return;
 if(window.SwellBundleSubscriptions)return;
 const CONFIG={bundleId:'2fa4323e-a56c-4316-893d-b5e8901ba2e2',planId:692395475257,variantIds:[50055522648377,50457676316985,50055522713913,50055522681145,50055522746681,51329293287737,51329293320505,51329293353273,51329293386041,51329293418809],tiers:[{min:1,percent:32},{min:2,percent:40.5},{min:4,percent:49},{min:8,percent:57.5}]};
 const ids=new Set(CONFIG.variantIds),route=window.Shopify?.routes?.root||'/';
 const ownCode=code=>/^SWELLBUNDLESUB(?:1|2|4|8)$/i.test(code||'');
 const planId=item=>Number(item.selling_plan_allocation?.selling_plan?.id)||0;
 const tagged=item=>ids.has(Number(item.variant_id))&&planId(item)===CONFIG.planId&&item.properties?._reploBundleId===CONFIG.bundleId;
 const codes=cart=>(cart.discount_codes||[]).filter(x=>typeof x.code==='string');
 const affected=cart=>cart.items.some(tagged)||codes(cart).some(x=>ownCode(x.code));
 const tier=n=>CONFIG.tiers.reduce((found,t)=>n>=t.min?t:found,null);
 const quantity=cart=>cart.items.filter(tagged).reduce((sum,item)=>sum+item.quantity,0);
 const desiredCode=cart=>quantity(cart)?'SWELLBUNDLESUB'+tier(quantity(cart)).min:'';
 let knownAffected=null,lastCart=null,lastError='',timer=null,queue=Promise.resolve(),checkoutPending=false,observer=null,hookTimer=null;
 const replayClicks=new WeakSet(),replayForms=new WeakSet();
 const pathFor=path=>route+path;
 async function request(path,body){
  const response=await window.fetch(pathFor(path),{credentials:'same-origin',cache:'no-store',...(body?{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)}:{})});
  let result;try{result=await response.json();}catch{throw new Error('We could not confirm your bundle savings. Please try again before checking out.');}
  if(!response.ok)throw new Error(result.description||result.message||'We could not update your bundle savings. Please try again.');
  return result;
 }
 function conflict(cart){
  if(!cart.items.some(tagged))return '';
  if(cart.items.some(item=>item.selling_plan_allocation&&!tagged(item)))return 'Your cart contains another subscription. Please check out those items separately to keep your bundle savings accurate.';
  if(cart.items.some(item=>ids.has(Number(item.variant_id))&&!item.selling_plan_allocation))return 'Your cart contains one-time bars and a subscription bundle. Please check out those items separately to keep the bundle savings accurate.';
  return '';
 }
 function priceValid(cart){
  const n=quantity(cart);if(!n)return true;
  const expected=cart.items.filter(tagged).reduce((sum,item)=>sum+Math.round((item.original_line_price/item.quantity)*(1-tier(n).percent/100))*item.quantity,0);
  const actual=cart.items.filter(tagged).reduce((sum,item)=>sum+item.final_line_price,0);
  return Math.abs(actual-expected)<=cart.items.filter(tagged).length;
 }
 function clearNotice(){document.getElementById('swell-bundle-checkout-notice')?.remove();lastError='';}
 function notice(message){
  lastError=message;
  let box=document.getElementById('swell-bundle-checkout-notice');
  if(!box){box=document.createElement('div');box.id='swell-bundle-checkout-notice';box.setAttribute('role','alert');box.style.cssText='position:fixed;z-index:2147483646;left:16px;right:16px;bottom:20px;max-width:620px;margin:auto;padding:16px 20px;background:#fffdf9;color:#293225;border:1px solid #a68150;border-radius:8px;box-shadow:0 4px 24px #29322530;font:14px/1.5 Montserrat,Arial,sans-serif';document.body?.append(box);}
  box.textContent=message;
 }
 function publishCart(cart){
  lastCart=cart;knownAffected=affected(cart);
  if(typeof window.SLIDECART_SET_CART==='function')window.SLIDECART_SET_CART(cart);
  document.dispatchEvent(new CustomEvent('swell:bundle-discount-confirmed',{detail:{quantity:quantity(cart),code:desiredCode(cart)}}));
 }
 async function inspect(reason){
  let cart;
  try{
   cart=await request('cart.js');lastCart=cart;knownAffected=affected(cart);
   if(!knownAffected){clearNotice();return {affected:false,verified:true,cart};}
   const issue=conflict(cart);if(issue)throw new Error(issue);
   const desired=desiredCode(cart),own=codes(cart).filter(x=>ownCode(x.code));
   const valid=desired?own.length===1&&own[0].code.toUpperCase()===desired&&own[0].applicable!==false:own.length===0;
   if(!valid){
    const next=codes(cart).filter(x=>!ownCode(x.code)).map(x=>x.code);if(desired)next.push(desired);
    await request('cart/update.js',{discount:next.join(',')});
    cart=await request('cart.js');lastCart=cart;knownAffected=affected(cart);
    if(desired&&!codes(cart).some(x=>x.code.toUpperCase()===desired&&x.applicable!==false))throw new Error('Your subscription savings could not be confirmed. Please try again before checking out.');
    publishCart(cart);
   }
   if(!priceValid(cart))throw new Error('Your bundle price could not be confirmed. Please return to Bundles or try again before checking out.');
   clearNotice();return {affected:affected(cart),verified:true,cart};
  }catch(error){
   if(knownAffected===true){notice(error.message||'Please review your bundle savings before checking out.');throw error;}
   // A network failure must not impose this bundle's guard on an unrelated cart.
   return {affected:false,verified:false,cart:lastCart};
  }
 }
 function reconcile(reason='manual'){
  const next=queue.catch(()=>{}).then(()=>inspect(reason));queue=next;return next;
 }
 function schedule(reason='cart-change'){
  clearTimeout(timer);timer=setTimeout(()=>{timer=null;reconcile(reason).catch(()=>{});},180);
 }
 function isCheckoutControl(control){
  if(!control)return false;
  if(control.matches('[name="checkout"],#checkout,#CartDrawer-Checkout,[data-swell-checkout]'))return true;
  if(control.tagName==='A'){
   try{const link=new URL(control.href,location.href);return link.origin===location.origin&&/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?checkout(?:\/|$)/i.test(link.pathname);}catch{return false;}
  }
  return false;
 }
 function checkoutForm(form,submitter){
  if(!form)return false;
  if(isCheckoutControl(submitter))return true;
  try{const url=new URL(form.action||location.href,location.href);return url.origin===location.origin&&/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?checkout(?:\/|$)/i.test(url.pathname);}catch{return false;}
 }
 async function beforeCheckout(resume){
  if(checkoutPending)return;checkoutPending=true;clearTimeout(timer);timer=null;
  try{const result=await reconcile('checkout');if(result.verified||result.affected===false)resume();}
  catch{/* Only a known affected cart is blocked; inspect already explains why. */}
  finally{checkoutPending=false;}
 }
 function clickCapture(event){
  const control=event.target?.closest?.('a,button,input');
  if(!isCheckoutControl(control))return;
  if(replayClicks.has(control)){replayClicks.delete(control);return;}
  if(knownAffected===false)return;
  if(event.defaultPrevented||event.button>0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
  // Leave unrelated checkout controls entirely untouched.
  event.preventDefault();event.stopImmediatePropagation();
  beforeCheckout(()=>{
   replayClicks.add(control);
   const form=control.form,type=(control.type||'').toLowerCase();
   if(form&&type==='submit')replayForms.add(form);
   control.click();
   if(form&&type==='submit')queueMicrotask(()=>replayForms.delete(form));
  });
 }
 function submitCapture(event){
  const form=event.target;
  if(replayForms.has(form)){replayForms.delete(form);return;}
  if(knownAffected===false)return;
  if(event.defaultPrevented||!checkoutForm(form,event.submitter))return;
  event.preventDefault();event.stopImmediatePropagation();const submitter=event.submitter;
  beforeCheckout(()=>{replayForms.add(form);if(typeof form.requestSubmit==='function')form.requestSubmit(submitter||undefined);else HTMLFormElement.prototype.submit.call(form);});
 }
 function installSlideCartHook(){
  const previous=window.SLIDECART_UPDATED;
  if(previous?._swellBundleReconciler)return;
  const wrapped=function(cart){const result=typeof previous==='function'?previous.apply(this,arguments):undefined;if(cart&&Array.isArray(cart.items)){lastCart=cart;knownAffected=affected(cart);schedule('slide-cart');}return result;};
  wrapped._swellBundleReconciler=true;window.SLIDECART_UPDATED=wrapped;
 }
 document.addEventListener('click',clickCapture,true);
 document.addEventListener('submit',submitCapture,true);
 document.addEventListener('change',event=>{if(event.target?.closest?.('form[action*="/cart"],#SLIDECART,#CartDrawer,[data-cart-drawer]'))schedule('cart-control');},true);
 for(const name of ['cart:updated','cart:change','cart:refresh','swell:cart-updated'])document.addEventListener(name,()=>schedule(name));
 window.addEventListener('pageshow',()=>schedule('pageshow'));
 document.addEventListener('visibilitychange',()=>{if(document.visibilityState==='visible')schedule('visible');});
 if(typeof PerformanceObserver==='function'){
  try{observer=new PerformanceObserver(list=>{for(const entry of list.getEntries()){const path=new URL(entry.name,location.href).pathname;if(/\/cart\/(?:add|change|update|clear)(?:\.js)?\/?$/.test(path)){schedule('cart-request-completed');break;}}});observer.observe({type:'resource',buffered:true});}catch{observer=null;}
 }
 installSlideCartHook();hookTimer=setInterval(installSlideCartHook,5000);
 window.addEventListener('load',installSlideCartHook,{once:true});
 window.SwellBundleSubscriptions={reconcile,verifyCheckout:()=>reconcile('checkout'),state:()=>({knownAffected,lastError}),disconnect:()=>{clearTimeout(timer);clearInterval(hookTimer);observer?.disconnect();document.removeEventListener('click',clickCapture,true);document.removeEventListener('submit',submitCapture,true);}};
 reconcile('initial').catch(()=>{});
})();
